<template>
  <div>
    <sweet-modal ref="new-member" class="modal-dashboard" width="60vw" hide-close-button>
      <div class="ba-flex ba-ai-center ba-jc-sb ba-mg-b-1">
        <h5 class="ba-color-blue1">{{ $t('ct-new-member-title') }}</h5>
        <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="$refs['new-member'].close()">
          <builderall-icon code='64f7' />
        </button>
      </div>
      <hr class='ba-hr-row'>
      <div class="ba-grid ba-mg-y-1" style="height: 500px; overflow-y: auto;">
        <form action="#" @submit.prevent="saveUser" ref="form-new-member" id="form-new-member"
          class="ba-grid ba-gp-08 ba-pd-r-1">
          <section class="ba-grid ba-gp-08">
            <p class="subtitle d-inline-block mb-0 ml-1">{{ $t("ct-members-data") }}</p>
            <hr class='ba-hr-row'>
            <div class="ba-grid ba-gp-08">
              <div class="ba-box-input ba-w-100">
                <label for="name" class="ba-custom-label">{{ $t('ct-name') }}</label>
                <input type="text" id="name" class="ba-input ba-md" v-model="user.name"
                  :class="{ 'iba-error': errors.has('name') }" :placeholder="$t('ct-name')"
                  @keydown="errors.clear('name')" required autocomplete="off" />
                <span v-if="errors.has('name')" class="ba-validation-text" v-text="errors.get('name')"></span>
              </div>

              <div class="ba-box-input ba-w-100">
                <label for="email" class="ba-custom-label">{{ $t('ct-email') }}</label>
                <input type="email" id="email" class="ba-input ba-md" v-model="user.email"
                  :class="{ 'ba-error': errors.has('email') }" :placeholder="$t('ct-email')"
                  @keydown="errors.clear('email')" required autocomplete="off" />
                <span v-if="errors.has('email')" class="ba-validation-text" v-text="errors.get('email')"></span>
              </div>

              <div class="ba-flex ba-w-100 ba-gp-08">
                <div class="ba-box-input ba-w-50">
                  <label for="password" class="ba-custom-label">{{ $t('ct-password') }}</label>
                  <input type="password" id="password" class="ba-input ba-md" v-model="user.password"
                    :class="{ 'ba-error': errors.has('password') }" :placeholder="$t('ct-password')"
                    @keydown="errors.clear('password')" required autocomplete="off" />
                  <span v-if="errors.has('password')" class="ba-validation-text" v-text="errors.get('password')"></span>
                </div>

                <div class="ba-box-input ba-w-50">
                  <label for="password-confirmation" class="ba-custom-label">{{ $t('ct-password-confirm') }}</label>
                  <input type="password" id="password-confirmation" name="password_confirmation" class="ba-input ba-md"
                    v-model="user.password_confirmation" :class="{ 'ba-error': errors.has('password_confirmation') }"
                    :placeholder="$t('ct-password-confirm')" @keydown="errors.clear('password_confirmation')" required
                    autocomplete="off" />
                  <span v-if="errors.has('password_confirmation')" class="ba-validation-text"
                    v-text="errors.get('password_confirmation')"></span>
                </div>
              </div>

              <div class="ba-grid ba-gp-08 ba-w-100" v-for="(field, index) in fields_custom" :key="field.order">
                <template v-if="!['checkbox', 'radio', 'select', 'textarea', 'datetime'].includes(field.type)">
                  <div class="ba-grid">
                    <label :for="field.label" class="ba-custom-label">{{ field.label }}</label>
                    <input :type="field.type" class="ba-input ba-md" :id="field.label" :name="field.tag"
                      v-model="user.fields_custom[field.tag]" :required="field.required === 1" autocomplete="off">
                    <small v-if="field.help_text && field.help_text.length > 0"
                      class="ba-montserrat-500 ba-text-12 ba-color-black18">{{
                        field.help_text }}</small>
                  </div>
                </template>

                <template v-else-if="field.type === 'select'">
                  <div class="ba-grid">
                    <label :for="field.label" class="ba-custom-label">{{ field.label }}</label>
                    <select class="ba-select ba-md" :id="field.label" :name="field.tag"
                      v-model="user.fields_custom[field.tag]" :required="field.required === 1">
                      <option v-for="(option, index) in field.options" :value="option.value" v-if="field.options">{{
                        option.name }}
                      </option>
                    </select>
                    <small v-if="field.help_text && field.help_text.length > 0"
                      class="ba-montserrat-500 ba-text-12 ba-color-black18">{{
                        field.help_text }}</small>
                  </div>
                </template>

                <template v-else-if="field.type === 'textarea'">
                  <div class="ba-grid">
                    <label :for="field.label" class="ba-custom-label">{{ field.label }}</label>
                    <textarea class="ba-textarea" :id="field.label" :name="field.tag"
                      v-model="user.fields_custom[field.tag]" rows="3"
                      :required="field.required === 1">{{ field.default_value }}</textarea>
                    <small v-if="field.help_text && field.help_text.length > 0"
                      class="ba-montserrat-500 ba-text-12 ba-color-black18">{{
                        field.help_text }}</small>
                  </div>
                </template>

                <template v-else-if="['checkbox', 'radio'].includes(field.type)">
                  <div class="ba-grid">
                    <label class="ba-custom-label">{{ field.label }}</label>
                    <div class="form-check" v-for="(option, index) in field.options" :key="index" v-if="field.options">
                      <input class="form-check-input" :type="field.type" :name="field.tag"
                        v-model="user.fields_custom[field.tag]" :id="option.value" :value="option.value"
                        :required="field.required === 1" :ref="field.tag" @change="changeRequired(field)">
                      <label class="form-check-label" :for="option.value">
                        {{ option.name }}
                      </label>
                    </div>
                    <small v-if="field.help_text && field.help_text.length > 0"
                      class="ba-montserrat-500 ba-text-12 ba-color-black18">{{
                        field.help_text }}</small>
                  </div>
                </template>

              </div>
            </div>
          </section>
          <hr class='ba-hr-row'>

          <section class="ba-grid ba-gp-08">
            <p class="subtitle d-inline-block mb-0 ml-1">{{ $t("ct-permissions") }}</p>
            <div class="ba-row">
              <div class="ba-flex ba-jc-sb ba-ai-start"
                v-for="(restrict_permission, index) in user.restrict_permissions" :key="index">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" :value="restrict_permission.restrict_area.id"
                    :id="`user-${restrict_permission.restrict_area.id}`" v-model="user.restrict_permissions_list"
                    :disabled="restrict_permission.restrict_area.type_id === 1 ||
                        restrict_permission.restrict_area.type_id === 4 ||
                        restrict_permission.has_expires_at
                        " />
                  <label class="form-check-label" :for="`user-${restrict_permission.restrict_area.id}`">
                    {{ restrict_permission.restrict_area.name }} ({{
                    $t(`ct-${restrict_permission.restrict_area.restrict_area_type.key}`)
                    }})
                  </label>
                </div>

                <template v-if="restrict_permission.restrict_area.type_id === 3">
                  <div class="ba-grid">
                    <div class="custom-control custom-switch form-group w-100">
                      <input type="checkbox" class="custom-control-input" @change="changeHasExpire(index)"
                        :id="`has-expire-date${index}`" :checked="restrict_permission.has_expires_at" />
                      <label class="custom-control-label" :for="`has-expire-date${index}`">{{
                        $t("ct-enable-date-expire") }}</label>
                    </div>
                    <div class="ba-grid" v-if="restrict_permission.has_expires_at">
                      <label for="permission-expire-date" class="ba-custom-label">{{ $t("ct-date-expire") }}</label>
                      <input class="ba-input ba-md" @change="changeExpireDate(index)" type="date" required
                        v-model="restrict_permission.expire" id="permission-expire-date" />
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </section>

          <button class="d-none" type="submit" ref="btn-submit"></button>
        </form>
      </div>
      <div class="ba-flex ba-ai-center ba-jc-fe ba-gp-1">
        <button slot="button" class="ba-btn ba-md ba-light" @click.prevent="$refs['new-member'].close()">{{
          $t('ct-cancel') }}</button>
        <button slot="button" class="ba-btn ba-md ba-blue" @click.prevent="handleSubmit()">{{ $t('ct-save')
          }}</button>
      </div>

    </sweet-modal>
  </div>
</template>

<script>
import { SweetModal } from "sweet-modal-vue";
import Errors from '../../../../js/base/Errors';
import { getAll as getAllFields } from '../../../../js/services/restrictArea/formFields';
import { create as createWebsiteUser } from '../../../../js/services/restrictArea/websiteUsers';

export default {
  name: 'NewMember',
  components: {
    SweetModal
  },

  props: ['website_id', 'layout_id', 'restrictAreas'],
  data() {
    return {
      errors: new Errors(),
      restrict_permission: {
        has_expires_at: false,
        updated: false
      },
      user: {
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        restrict_permissions_list: [],
        restrict_permissions: [],
        fields_custom: {}
      },

      fields_custom: {}
    };
  },

  methods: {
    open() {
      this.setUserValues();
      this.$refs['new-member'].open();
    },

    close() {
      this.$refs['new-member'].close();
    },

    handleSubmit() {
      this.$refs['btn-submit'].click();
    },

    saveUser() {
      this.user.fields_custom_config = this.fields_custom;
      this.user.areas_register = this.restrict_permissions_list;

      if (this.errors.any() && this.$refs['form-new-member'].querySelector('.is-invalid'))
        this.$refs['form-new-member'].querySelector('.is-invalid').focus();

      if (
        this.user.name &&
        this.user.email &&
        this.user.password &&
        this.user.password_confirmation &&
        !this.errors.any()
      ) {
        this.errors.clear();
        this.$loading.show();

        createWebsiteUser({ ...this.user, website_id: this.website_id, time_zone: this.$getTimeZone() })
          .then(({ data }) => {
            if (data.success) {
              this.clearData();
              this.close();
              this.$emit('reloadUsers');
              this.$snotify.success(this.$t('ct-success-true'), {
                position: 'centerTop'
              });
            } else {
              if (data.validator) {
                this.errors.record(data.errors);
                setTimeout(() => this.$refs['form-new-member'].querySelector('.is-invalid').focus(), 150);
              }
            }
          })
          .catch(error => {
            this.$snotify.error(this.$t('ct-success-false'), {
              position: 'centerTop'
            });
          })
          .finally(() => this.$loading.hide());
      }
    },

    clearData() {
      this.user = {
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        fields_custom: {},
        restrict_permissions_list: [],
        restrict_permissions: []
      };
    },

    setUserValues() {
      this.clearData();

      this.restrictAreas.map(restrict => {
        let userPermission = {
          active: false,
          expire: null,
          has_expires_at: null,
          restrict_area_id: restrict.id,
          restrict_area: restrict
        };

        if (restrict.type_id === 1) this.user.restrict_permissions_list.push(restrict.id);

        this.user.restrict_permissions.push(userPermission);
      });

      this.fields_custom.map(field => {
        if (field.type === 'checkbox' || field.type === 'radio')
          this.user.fields_custom[field.tag] = [];
        else
          this.user.fields_custom[field.tag] = '';
      });
    },

    changeExpireDate(index) {
      let vm = this;
      let user = { ...this.user };
      let restrict_permissions = [...this.user.restrict_permissions];

      var dateExpire = new Date(restrict_permissions[index].expire);
      var dateNow = new Date();

      dateExpire.setHours(0);
      dateExpire.setMinutes(0);
      dateExpire.setSeconds(0);
      dateExpire.setMilliseconds(0);

      dateNow.setHours(0);
      dateNow.setMinutes(0);
      dateNow.setSeconds(0);
      dateNow.setMilliseconds(0);

      restrict_permissions[index].has_expires_at = true;
      restrict_permissions[index].updated = true;

      if (dateNow <= dateExpire) {
        user.restrict_permissions_list.push(
          restrict_permissions[index].restrict_area_id
        );

        restrict_permissions[index].active = true;
      } else {
        user.restrict_permissions_list = this.user.restrict_permissions_list.filter(
          id => id !== restrict_permissions[index].restrict_area_id
        );

        restrict_permissions[index].active = false;
      }

      user.restrict_permissions = restrict_permissions;
      vm.user = Object.assign({}, vm.user, user);
    },

    changeHasExpire(index) {
      let vm = this;
      let user = { ...this.user };
      let restrict_permissions = [...this.user.restrict_permissions];
      restrict_permissions[index].updated = true;

      if (restrict_permissions[index].has_expires_at) {
        restrict_permissions[index].has_expires_at = false;
        restrict_permissions[index].expire = false;
      } else restrict_permissions[index].has_expires_at = true;

      user.restrict_permissions = restrict_permissions;
      vm.user = Object.assign({}, vm.user, user);
    },

    changeRequired(field) {
      if (this.user.fields_custom[field.tag].length > 0 && field.required) {
        this.$refs[field.tag].map(field => {
          field.required = false;
        });
      } else if (field.required) {
        this.$refs[field.tag].map(field => {
          field.required = true;
        });
      }
    }
  },

  created() {
    getAllFields(this.website_id)
      .then(({ data }) => {
        if (data.success)
          this.fields_custom = data.data;
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>

<style lang="scss" scoped>
.subtitle {
  font-family: "Muli", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  color: #434343;
}

.container-user {
  padding-right: 1.5rem;
  padding-left: 1.5rem;
  width: 100%;
  font-size: 14px;

  .form-group {
    label {
      color: #434343;
      font-size: 14px;
      font-weight: bold;
    }
  }

  .card-fields {
    p {
      flex: 1;
    }
  }

  .card-permissions {
    margin-right: -5px;
    margin-left: -5px;
    padding: 1rem 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/pages/MembersArea/NewMember.vue